import { Tooltip, TooltipProps } from '@components/common/Tooltip/Tooltip';
import { BothOrNeither, cloneElementWithClass } from '@utils';
import { ReactNode } from 'react';

type BaseIconButtonProps = {
  onClick: () => void;
  icon: ReactNode;
  hoverTooltip?: TooltipProps;
  dataTestId?: string;
};

type DisabledProps = BothOrNeither<
  { disabled: boolean },
  { disabledTooltip: TooltipProps }
>;

type Props = BaseIconButtonProps & DisabledProps;

export const IconButton = ({
  onClick,
  icon,
  hoverTooltip,
  disabled,
  disabledTooltip,
  dataTestId,
}: Props) => {
  const Icon = icon ? cloneElementWithClass(icon, 'h-6 w-6') : null;

  const iconButton = (
    <button
      type="button"
      onClick={onClick}
      className="focus-visible:ring-product-dark relative rounded-full bg-transparent text-gray-900 hover:text-gray-400 focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:text-gray-500"
      disabled={disabled}
      data-testid={dataTestId}
    >
      {Icon}
    </button>
  );

  if (disabled && disabledTooltip) {
    return (
      <Tooltip {...disabledTooltip}>
        {/* tooltip wraps with `inline`; `flex` prevents misalignment within the tooltip container */}
        {cloneElementWithClass(iconButton, 'flex')}
      </Tooltip>
    );
  }

  if (hoverTooltip) {
    return <Tooltip {...hoverTooltip}>{iconButton}</Tooltip>;
  }

  return iconButton;
};
